import { render, staticRenderFns } from "./Associando.vue?vue&type=template&id=32051ff9"
import script from "./Associando.vue?vue&type=script&lang=js"
export * from "./Associando.vue?vue&type=script&lang=js"
import style0 from "./Associando.vue?vue&type=style&index=0&id=32051ff9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports